import { Mark } from '@tiptap/core'

export const StrongMark = Mark.create({
  name: 'strong',

  addOptions() {
    return {
      HTMLAttributes: {},
    }
  },

  parseHTML() {
    return [
      {
        tag: 'b',
      },
    ]
  },

  renderHTML({ HTMLAttributes }) {
    return ['b', HTMLAttributes, 0]
  },
})
